<page-headline
    [linkTitle]="''"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
</page-headline>
<div style="display: flex; justify-content: space-between">
    <main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
    <div class="displayopt-layout">
        <search-dialog
            (searchOutput)="searchRows($event)"
            [searchId]="'leaderboard-rankings-branch'"
            [searchBoxHeight]="44"
            [resetSearch]="false"
        >
        </search-dialog>
    </div>
</div>
<div style="display: flex; align-items: center">
    <div class="entity-ddl">
        <angular2-multiselect
            [data]="entityList"
            [(ngModel)]="selectedEntity"
            [settings]="entityListSettings"
            (onSelect)="onSelectionChange($event)"
        >
        </angular2-multiselect>
    </div>
    <display-options
        (displayOptionsOutput)="applyDisplayOptions($event)"
        [showCompareToDate]="false"
    >
    </display-options>
    <div class="displayopt-layout" style="margin-top: -27px">
        <action-panel
            [showExportCsv]="false"
            [showSaveAsPdf]="true"
            [showPrint]="false"
            [title]="pageHeadline.pageTitle"
        >
        </action-panel>
    </div>
</div>

<kendo-grid
    class="lg-kendo-grid ranking-report-table lg-scrollbar"
    [data]="gridView"
    [pageable]="pageable"
    [pageSize]="pageSize"
    [skip]="skip"
    [loading]="loading"
    [sort]="sort"
    [sortable]="sortable"
    (sortChange)="sortChange($event)"
    (pageChange)="pageChange($event)"
>
    <ng-template kendoGridNoRecordsTemplate>
        <div class="no-data-message-area" *ngIf="!loading && noDataForCompany">
            <no-data-screen [noDataType]="noDataType"></no-data-screen>
        </div>
    </ng-template>
    <kendo-grid-column
        field="hierarchyName"
        title="{{ roleName }}"
        [style]="{ width: '11.3%' }"
        [headerStyle]="{ width: '11.3%' }"
    >
        <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.hierarchyName }}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="revenueValues"
        title="Revenue {{ viewByParam === 'trend' ? 'Trend' : 'Change' }}"
        [sortable]="false"
        [style]="{ width: '12.5%' }"
        [headerStyle]="{ width: '12.5%' }"
    >
        <ng-template kendoGridCellTemplate let-dataItem>
            <div id="revenueValues{{ dataItem.hierarchyName }}" class="revenue-trends-charts"></div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="totalRevenue"
        title="Total Revenue"
        [style]="{ width: '10.1%' }"
        [headerStyle]="{ width: '10.1%' }"
    >
        <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.totalRevenue | currency: 'USD':'symbol':'1.0-0' }}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="expenseValues"
        title="Expense {{ viewByParam === 'trend' ? 'Trend' : 'Change' }}"
        [sortable]="false"
        [style]="{ width: '12.5%' }"
        [headerStyle]="{ width: '12.5%' }"
    >
        <ng-template kendoGridCellTemplate let-dataItem>
            <div id="expenseValues{{ dataItem.hierarchyName }}" class="revenue-trends-charts"></div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="totalExpense"
        title="Total Expenses"
        [style]="{ width: '10.1%' }"
        [headerStyle]="{ width: '10.1%' }"
    >
        <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.totalExpense | currency: 'USD':'symbol':'1.0-0' }}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="netPeriodValues"
        title="Net Income {{ viewByParam === 'trend' ? 'Trend' : 'Change' }}"
        [sortable]="false"
        [style]="{ width: '12.5%' }"
        [headerStyle]="{ width: '12.5%' }"
    >
        <ng-template kendoGridCellTemplate let-dataItem>
            <div
                id="netPeriodValues{{ dataItem.hierarchyName }}"
                class="revenue-trends-charts"
            ></div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="netIncome"
        title="Net Income"
        [style]="{ width: '10.1%' }"
        [headerStyle]="{ width: '10.1%' }"
    >
        <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.netIncome | currency: 'USD':'symbol':'1.0-0' }}
        </ng-template>
    </kendo-grid-column>
</kendo-grid>
